import { useState } from "react";
import { Award, Eye, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const templates = [
  { kind: "association_appreciation", label: "شهادة شكر وتقدير للجمعية", description: "معاينة باسم جمعية تجريبي" },
  { kind: "training_completion", label: "شهادة حضور وإتمام التدريب التعاوني", description: "معاينة صياغة الطالب أو الطالبة" },
  { kind: "training_excellence", label: "شهادة امتياز", description: "معاينة الدرجة والتوقيع" },
];

export default function CertificateTemplatePreviews() {
  const [gender, setGender] = useState("female");
  const [previewing, setPreviewing] = useState("");
  const preview = async (kind) => {
    setPreviewing(kind);
    try {
      const response = await api.post(`/certificates/templates/${kind}/preview`, {
        gender,
        student_name: gender === "female" ? "سارة بنت خالد" : "أحمد بن علي",
        association_name: "جمعية التنمية المجتمعية",
        program_name: "برنامج تطوير القيادات الشابة",
        start_date: "01/09/2026",
        end_date: "30/11/2026",
        hours: 240,
        score: 95,
        official_name: "اسم المسؤول المعتمد",
        official_title: "المشرف الداخلي بالجمعية",
        issue_date: "30/11/2026",
      }, { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      window.open(url, "_blank", "noopener,noreferrer");
      window.setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setPreviewing("");
    }
  };
  return <section className="mb-8 rounded-3xl border border-teal-100 bg-teal-50/40 p-5" data-testid="certificate-template-previews">
    <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
      <div><h2 className="font-heading text-lg font-black text-slate-900">معاينة قوالب الشهادات الجديدة</h2><p className="mt-1 text-sm text-slate-600">معاينة فقط — لا تنشئ شهادة ولا تحفظ بيانات.</p></div>
      <select value={gender} onChange={(event) => setGender(event.target.value)} className="min-h-11 rounded-xl border border-slate-300 bg-white px-4 text-sm" data-testid="certificate-preview-gender">
        <option value="female">صياغة طالبة</option>
        <option value="male">صياغة طالب</option>
      </select>
    </div>
    <div className="mt-4 grid gap-3 md:grid-cols-3">
      {templates.map((item) => <article key={item.kind} className="rounded-2xl border border-slate-200 bg-white p-4">
        <Award className="h-6 w-6 text-teal-700"/>
        <h3 className="mt-3 font-bold text-slate-900">{item.label}</h3>
        <p className="mt-1 min-h-10 text-xs text-slate-500">{item.description}</p>
        <button onClick={() => preview(item.kind)} disabled={!!previewing} className="mt-4 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 text-sm font-bold text-white disabled:opacity-50" data-testid={`preview-${item.kind}`}>
          {previewing === item.kind ? <Loader2 className="h-4 w-4 animate-spin"/> : <Eye className="h-4 w-4"/>} فتح المعاينة
        </button>
      </article>)}
    </div>
  </section>;
}
